import * as React from "react";
import mark from "../../../../assets/images/Red exclamation mark.svg"
import allCompleteNanu from "../../../../assets/images/all_complete_nanu.png"
import allCompleteCheck from "../../../../assets/images/Check mark button.png"


const NonParticipants = ({inCompletedStudentList, classStageStudentList}) => {
    const chunkArray = (array, size) => {
        const chunkedArr = [];
        for (let i = 0; i < array.length; i += size) {
            chunkedArr.push(array.slice(i, i + size));
        }
        return chunkedArr;
    };

    const rows = chunkArray(inCompletedStudentList, 3); // 3명씩 나눔


    return (
        <div
            className="flex flex-col px-5 py-6 h-full mx-auto w-full bg-white rounded-3xl border border-solid border-zinc-300 shadow-[0px_2px_7px_rgba(0,0,0,0.1)] max-md:mt-5">
            {inCompletedStudentList && inCompletedStudentList.length > 0 ? (
                <>
                    <div className="flex gap-2 self-start text-base text-zinc-600 max-md:ml-1  w-full">
                        <img
                            loading="lazy"
                            src={mark}
                            alt="exclamation mark icon"
                            className="object-contain shrink-0 w-8 aspect-square"
                        />
                        <div className="flex gap-1.5 justify-center items-center my-auto w-full">
                            <div className="my-auto text-base basis-auto text-left font-black">
                                학습을 진행하지 않았어요.
                            </div>
                            <div
                                className="flex flex-col self-stretch my-auto w-12 text-sm font-semibold text-center text-rose-500 whitespace-nowrap rounded-[100px] ml-auto">
                                <div className="gap-2 self-stretch px-2 py-1 bg-rose-200 min-h-[22px] rounded-[100px]">
                                    {inCompletedStudentList.length}명
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ml-11 text-sm font-medium text-neutral-400 text-left ">
                    학습을 진행할 수 있도록
                    <br />
                    지도해 주세요.
                    </div>
                    <div className="max-h-[224px]" // 스크롤 활성화 및 최대 높이 설정
                    style={{
                        scrollbarWidth: "thin", // 스크롤바 두께 조정 (Firefox용)
                        overflowY: "overlay", // 스크롤 영역이 콘텐츠 위에 겹쳐 표시
                    }}>
                    {rows.map((row, rowIndex) => (
                        <div
                            key={rowIndex}
                            className="flex gap-1 items-center mt-3.5 text-sm font-semibold text-center text-gray-600 whitespace-nowrap"
                        >
                            {row.map((student, colIndex) => (
                                <div
                                    key={`${rowIndex}-${colIndex}`}
                                    className="overflow-hidden gap-px self-stretch  px-2 py-1 my-1 bg-rose-50 rounded-2xl h-[37px] w-[96px] text-ellipsis whitespace-nowrap leading-[29px]"
                                >
                                    {student}
                                </div>
                            ))}
                        </div>
                        ))}
                    </div>
                </>
                ) : (
                <>
                    <div className="flex gap-2 self-start text-base text-zinc-600 max-md:ml-1  w-full">
                        <img
                            loading="lazy"
                            src={allCompleteCheck}
                            alt="all complete check"
                            className="object-contain shrink-0 w-8 aspect-square"
                        />
                        <div className="flex gap-1.5 justify-center items-center my-auto w-full">
                            <div className="my-auto text-base basis-auto text-left font-black">
                                모두 학습을 완료했어요~
                            </div>
                            <div
                                className="flex flex-col self-stretch my-auto w-12 text-sm font-semibold text-center text-blue-500 whitespace-nowrap rounded-[100px] ml-auto">
                                <div className="gap-2 self-stretch px-2 py-1 bg-[#D7E5FE] min-h-[22px] rounded-[100px]">
                                    {classStageStudentList.length}명
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ml-11 text-sm font-medium text-neutral-400 text-left ">
                        학생들을 칭찬해주세요.
                    </div>
                    <div className="flex items-end justify-center h-[300px]" // 스크롤 활성화 및 최대 높이 설정
                        >
                         <img
                             loading="lazy"
                             src={allCompleteNanu}
                             alt="all complete nanu"
                             className="w-[260px] h-[210px]"
                         />
                    </div>
                </>
            )}
        </div>
    );
}

export default NonParticipants;